import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import banner from '../../assets/images/otrlogo.png';

export default function NOAVerified() {
    const [verified, setVerified] = useState(false);
    const [invoiceDetails, setInvoiceDetails] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');


    const [searchParams] = useSearchParams();
    const guid = searchParams.get('guid');

    useEffect(() => {
    const invoicesBaseUrl = process.env.REACT_APP_INVOICES_APIM_BASE_URL;
    const acknowledgementUrl = new URL('broker-acknowledgement', invoicesBaseUrl as string);
    const invoiceDetailsUrl = new URL('invoice-details', invoicesBaseUrl as string);
        if (!guid) {
            setErrorMessage('No GUID provided in the URL.');
            setError(true);
            setLoading(false);
            return;
        }

        fetch(acknowledgementUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY_VALUE as string,
            },
            body: JSON.stringify({ guid }),
        })
            .then(async (response) => {
                const data = await response.json();

                if (!response.ok) {
                    const parsedError = data?.errors?.[0] || 'Verification failed';
                    throw new Error(parsedError);
                }

                setVerified(true);
                return data?.InvoicePKey;
            })
            .then(async (pkey) => {
                if (pkey) {
                    const url = `${invoiceDetailsUrl}?invoicePKey=${pkey}`;
                    const response = await fetch(url, {
                        headers: {
                            'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBSCRIPTION_KEY_VALUE as string,
                        },
                    });

                    if (!response.ok) {
                        throw new Error('Failed to load invoice details.');
                    }

                    const details = await response.json();
                    setInvoiceDetails(details);
                }
            })
            .catch((err) => {
                setErrorMessage(err.message);
                setError(true);
            })
            .finally(() => setLoading(false));
    }, [guid]);

    if (loading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
                <p className="text-lg text-gray-600 dark:text-gray-300">Checking verification status...</p>
            </div>
        );
    }

    if (verified) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
                <div className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-10 w-9/10 sm:w-3/4 lg:w-1/2 max-w-2xl text-center">
                    <img src={banner} alt="OTR Banner" className="mx-auto mb-6 w-80 rounded" />
                    <h2 className="text-3xl font-semibold text-gray-700 dark:text-gray-200">Thank You for Your Partnership</h2>
                    <p className="mt-6 text-lg text-gray-600 dark:text-gray-300">
                        Please reach out to your OTR Representative if there are any outstanding claims or disputes with
                        <span className="font-medium dark:text-gray-400"> {invoiceDetails.Client?.Name}</span>.
                    </p>

                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 p-6">
                <div className="bg-white dark:bg-gray-800 shadow-lg rounded-2xl p-10 w-9/10 sm:w-3/4 lg:w-1/2 max-w-2xl text-center">
                    <h2 className="text-2xl font-semibold text-red-600 dark:text-red-400 mb-4">Verification Failed</h2>
                    <p className="text-lg text-gray-700 dark:text-gray-300">{errorMessage}</p>
                </div>
            </div>
        );
    }

    return null;
}
